import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {ActivityVO,  ActivityListVO} from './activity.interfaces';
import {activityDefinition, ActivityState} from './activity.reducers';
import {FullCrudFacade, PayloadWithRequestId, TerminateOnFirstExecutor} from '@abydos-angular/store';
import {ActivityRepository} from './activity.repository';
import {RestResponse} from '@abydos-angular/core';
@Injectable()
export class ActivityFacade extends FullCrudFacade<ActivityVO, ActivityListVO, ActivityState> {

    constructor(store: Store<ActivityState>, private activityRepository: ActivityRepository) {
        super(store, activityDefinition);
    }

    getWithCallback(idValue: number, onSuccess: (result: ActivityVO | null | undefined) => void) {
        new TerminateOnFirstExecutor((result:PayloadWithRequestId<ActivityVO>) => {
          onSuccess(result.payload);
        }).run(this.activityRepository.get(idValue));
    }

    getPartnerDocumentWithCallback(idValue: number, onSuccess: (result: any) => void) {
        new TerminateOnFirstExecutor((result: RestResponse) => {
            onSuccess(result.getFirstData());
        }).run(this.activityRepository.getPartnerDocument(idValue));
    }
}
